import { Card, CardContent, Box, Typography, Chip } from '@material-ui/core';
import { TrendingUp, TrendingDown } from '@material-ui/icons';
import Chart from 'react-apexcharts';

// Shared visual shell used by every per-metric chart component.
// Each metric chart provides its own series + options + caption.
const ChartShell = ({
  title,
  value,
  trend,
  trendValue,
  icon: Icon,
  caption,
  type = 'area',
  options,
  series,
  height = { xs: 280, md: 380 }
}) => {
  const isUp = trend === 'up';

  return (
    <Card elevation={2}>
      <CardContent sx={{ p: { xs: 2, md: 4 } }}>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, mb: 3, flexWrap: 'wrap' }}>
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: 2,
              bgcolor: 'primary.main',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0
            }}
          >
            {Icon && <Icon sx={{ color: 'primary.contrastText', fontSize: 32 }} />}
          </Box>
          <Box sx={{ flex: 1, minWidth: 200 }}>
            <Typography variant="subtitle2" color="text.secondary">
              {title}
            </Typography>
            <Typography variant="h4" color="text.primary" sx={{ fontWeight: 700 }}>
              {value}
            </Typography>
          </Box>
          {trendValue && (
            <Chip
              icon={isUp ? <TrendingUp fontSize="small" /> : <TrendingDown fontSize="small" />}
              label={trendValue}
              size="small"
              sx={{
                fontWeight: 700,
                bgcolor: isUp ? 'success.main' : 'error.main',
                color: '#fff',
                '& .MuiChip-icon': { color: '#fff' }
              }}
            />
          )}
        </Box>

        {caption && (
          <Typography variant="overline" color="text.secondary">
            {caption}
          </Typography>
        )}
        <Box sx={{ width: '100%', height, mt: 1 }}>
          <Chart options={options} series={series} type={type} height="100%" width="100%" />
        </Box>
      </CardContent>
    </Card>
  );
};

export default ChartShell;
